import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageRouter } from './components/LanguageRouter';
import { REDLayout, type MetaNavLink } from './components/red/REDLayout';
import headerImgHomePage from './components/red/imageLib/visual_geschaeftsreisen_1280x540.avif';
import { HomePage } from './pages/HomePage';

// Default meta navigation links for bahn.business project
const defaultMetaNavLinks: MetaNavLink[] = [
  {
    translationKey: 'common:helpContact',
    href: 'https://www.bahn.de/bahnbusiness/hilfe',
    target: '_blank'
  }
];

// Blue Business Meta Navigation - applies blue background (#0a1e6e) to meta navigation
const BLUE_BUSINESS_META_NAV = true;

// Main App Content
const AppContent = () => {
  const { i18n } = useTranslation();

  // Brand name based on current language
  const brandName = i18n.language === 'en'
    ? 'bahn.business registration'
    : 'bahn.business - Anmeldung';

  // Sync HTML lang attribute and document title with i18n language
  React.useEffect(() => {
    document.documentElement.lang = i18n.language;
    // Update document title based on language
    document.title = i18n.language === 'en' ? 'bahn.businesss - Registration' : 'bahn.businesss - Anmeldung';
  }, [i18n.language]);

  return (
    <LanguageRouter>
      <Routes>
        {/* Root redirect to language-prefixed path */}
        <Route path="/" element={<Navigate to={`/${i18n.language || 'de'}`} replace />} />

        {/* Language-prefixed routes */}
        <Route path="/:locale">
          {/* Home page with BTM form */}
          <Route
            index
            element={
              <REDLayout
                pageMaxWidth1280
                hasOverlayImage={true}
                headerImg={headerImgHomePage}
                brandName={brandName}
                blueBusinessMetaNavigation={BLUE_BUSINESS_META_NAV}
                metaNavigationLinks={defaultMetaNavLinks}
              >
                <HomePage />
              </REDLayout>
            }
          />
        </Route>

        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to={`/${i18n.language || 'de'}`} replace />} />
      </Routes>
    </LanguageRouter>
  );
};

// Main App Component
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;